import { Button, ButtonSize } from '../../Button'
import { Icon } from '../../Icon'
import { useCascadingMenu } from '../Root'
import * as styles from '../styles'

export const RootHeader: React.FC = () => {
  const { stackLevel, rootHeader } = useCascadingMenu()

  if (stackLevel === 1) return null
  if (!rootHeader) return null

  return (
    <div css={styles.headerItem}>
      <span css={styles.headerItemText}>{rootHeader}</span>
    </div>
  )
}
RootHeader.displayName = 'Lapidary: CascadingMenu.RootHeader'

type SubmenuHeaderProps = Readonly<{
  title: string
}>

export const SubmenuHeader: React.FC<SubmenuHeaderProps> = ({ title }) => {
  const { ascendMenuLevel } = useCascadingMenu()
  return (
    <div css={styles.headerItem}>
      <Button
        name="back"
        size={ButtonSize.Small}
        icon={<Icon ariaHidden={true} glyph="gem-chevron-w" />}
        variant="ghost"
        onClick={ascendMenuLevel}
      />
      <span css={styles.headerItemText}>{title}</span>
    </div>
  )
}
SubmenuHeader.displayName = 'Lapidary: CascadingMenu.SubmenuHeader'
